import './index.css';
import View from '../view';
import Text from '../text';
import useTheme from '../../utilities/hooks/theme';
import React from 'react';

interface Props {
  item: any;
}

const EmailDetails = ({ item }: Props) => {
  const { ComponentTheme: theme } = useTheme();
  const headerContainer = {
    backgroundColor: theme.verifyAccountItemHeaderContainer,
    borderTopColor: theme.verifyAccountItemContent
  };

  const headerTitle = {
    color: theme.verifyAccountItemTitle
  };
  const defaultEmail = item?.email || '';

  return (
    <View className={'email-details-header-container'} style={headerContainer}>
      <View className={'email-details-content-container'}>
        <Text className={'email-details-title'} style={headerTitle}>
          {'Email Id '}
        </Text>
        <Text style={headerTitle} className={'email-details-colon'}>
          {' : '}
        </Text>
        <Text className={'email-details-value'} style={headerTitle}>{`${defaultEmail}`}</Text>
      </View>
    </View>
  );
};
export default React.memo(EmailDetails);
